import React from "react";
import { CasesList } from "sections/CasesNew/";
import { TitleS } from "components/Typography";
import { Button } from "components/Buttons";
import { Container, ButtonWrapper, TitleWrapper } from "./styles";

export const OurCases = ({ data }) => {
  return (
    <Container>
      <TitleWrapper>
        <TitleS underline>Wybrane realizacje</TitleS>
      </TitleWrapper>
      <CasesList data={data} />
      <ButtonWrapper>
        <Button to="/realizacje">Zobacz wszystkie</Button>
      </ButtonWrapper>
    </Container>
  );
};
